import { cn } from '@/utils/cn';
import type { ActionMenuItem } from './ActionMenu';
import { ActionMenuIcon } from './ActionMenuIcon';

interface ActionMenuMobileProps {
  items?: ActionMenuItem[];
  className?: string;
}

export function ActionMenuMobile({ items = [], className }: ActionMenuMobileProps) {
  return (
    <div className={cn('flex items-center justify-end gap-2', className)}>
      {items.map((item) => {
        return (
          <button
            key={item.label}
            type="button"
            title={item.label}
            disabled={item.disabled}
            onClick={(event) => {
              event.stopPropagation();
              if (item.disabled) return;
              item.onClick?.();
            }}
            className={cn(
              'flex h-8 w-8 items-center justify-center rounded-md border border-slate-200 bg-white text-slate-500 shadow-sm transition-all hover:bg-slate-50 hover:text-slate-700 disabled:cursor-not-allowed disabled:opacity-50',
              item.destructive && 'border-red-200 text-red-600 hover:bg-red-50 hover:text-red-700',
            )}
          >
            {item.icon ? <ActionMenuIcon icon={item.icon} className="h-4 w-4 shrink-0" /> : <span className="text-[10px]">{item.label.substring(0, 2)}</span>}
          </button>
        );
      })}
    </div>
  );
}
